function l(t, r, e, n, a, u, o, f, _) {
  switch (arguments.length) {
    case 1:
      return t;
    case 2:
      return r(t);
    case 3:
      return e(r(t));
    case 4:
      return n(e(r(t)));
    case 5:
      return a(n(e(r(t))));
    case 6:
      return u(a(n(e(r(t)))));
    case 7:
      return o(u(a(n(e(r(t))))));
    case 8:
      return f(o(u(a(n(e(r(t)))))));
    case 9:
      return _(f(o(u(a(n(e(r(t))))))));
    default: {
      for (var c = arguments[0], i = 1; i < arguments.length; i++)
        c = arguments[i](c);
      return c;
    }
  }
}
globalThis && globalThis.__spreadArray;
var h = { _tag: "None" }, m = function(t) {
  return { _tag: "Some", value: t };
}, s = function(t) {
  return t._tag === "Left";
}, A = function(t) {
  return { _tag: "Left", left: t };
}, w = function(t) {
  return { _tag: "Right", right: t };
}, E = h, N = m, P = function(t) {
  return t._tag === "None";
}, S = function(t) {
  return function(r) {
    return P(r) ? t() : r.value;
  };
}, $ = S, C = function(t) {
  return t == null ? E : N(t);
}, v = /* @__PURE__ */ ((t) => (t.AE = "auto_equity", t.AF = "auto_fin", t.BE = "benefits", t.CA = "creditas_auto", t.CAC2C = "creditas_auto_c2c", t.CR = "cross", t.HE = "home_equity", t.HS = "home_solutions", t.IS = "insurance", t.IN = "institutional", t.MX = "mexico", t.PA = "partnership", t.PAE = "partnership_auto_equity", t.PHE = "partnership_home_equity", t.PIS = "partnership_insurance", t))(v || {});
const k = (t, r) => {
  const e = {}, n = t[0](r);
  return e.page = n.page, e.identify = n.identify, e.track = n.track, e;
};
var q = A, y = w, g = function(t) {
  return function(r) {
    return L(r) ? r : y(t(r.right));
  };
}, L = s, p = function(t) {
  return function(r) {
    return r == null ? q(t) : y(r);
  };
};
function d(t) {
  return {
    name: "segment-plugin",
    page: (...r) => {
      l(
        window.analytics,
        p("nully"),
        g((e) => {
          e.page(...r);
        })
      );
    },
    track: (...r) => {
      r[1] = { ...t, ...r[1] }, l(
        window.analytics,
        p("nully"),
        g((e) => {
          e.track(...r);
        })
      );
    },
    identify: (...r) => {
      l(
        window.analytics,
        p("nully"),
        g((e) => {
          e.identify(...r);
        })
      );
    }
  };
}
const x = (t) => {
  const r = l(
    t.plugins,
    C,
    $(() => [d])
  ), e = {
    bu: v[t.bu],
    application: t.application
  };
  return k(r, e);
};
export {
  x as configure
};
